export async function fetchWithStateHandling(
  fetchFunction: () => Promise<void>,
): Promise<{ isLoading: Ref<boolean>; isError: Ref<boolean> }> {
  const isLoading = ref(false);
  const isError = ref(false);

  try {
    isLoading.value = true;
    isError.value = false;
    await fetchFunction();

    isLoading.value = false;
  } catch {
    isLoading.value = false;
    isError.value = true;
  }

  return { isLoading, isError };
}
